import {
  Button,
  FormHelperText,
  Stack,
  SxProps,
  Typography,
} from '@mui/material';
import { DynamicArrow } from 'Components/DynamicArrow';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';

interface IFormActionButtons {
  next: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  nextType?: 'reset' | 'submit';
  previous?: () => void;
  nextDisabled?: boolean;
  previousDisabled?: boolean;
  errorMessage?: string;
  backButtonSx?: SxProps;
  primaryButtonSx?: SxProps;
}

export const FormActionButtons = ({
  next,
  nextType,
  previous,
  nextDisabled,
  previousDisabled,
  errorMessage,
  backButtonSx,
  primaryButtonSx,
}: IFormActionButtons) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      position={isDesktop ? 'static' : 'sticky'}
      bottom={isDesktop ? undefined : 0}
      width={isDesktop ? '100%' : '100vw'}
      marginLeft={isDesktop ? '0' : '-24px'}
      bgcolor={isDesktop ? 'transparent' : '#fff'}
      height={isDesktop ? 'auto' : '100px'}
      justifyContent={'center'}
      zIndex={isDesktop ? undefined : 1}
    >
      {errorMessage && (
        <FormHelperText
          sx={{ alignSelf: 'flex-start', ml: '24px' }}
          role={'alert'}
          error
        >
          {errorMessage}
        </FormHelperText>
      )}
      <Stack
        direction='row'
        height={isDesktop ? '46px' : '36px'}
        justifyContent='center'
        alignItems='center'
        gap='24px'
      >
        {!previousDisabled && (
          <Button
            variant='secondary1'
            sx={{
              width: isDesktop ? '180px' : '122px',
              gap: '4px',
              p: 0,
              '&:disabled': { opacity: '.4', color: 'text.secondary' },
              ...backButtonSx,
            }}
            onClick={previous}
            type={nextType}
          >
            <Stack direction={'row'} alignItems={'flex-end'} width={'auto'}>
              <DynamicArrow color={'blue'} rotate={-90} />
              <Typography variant={'body4'}>
                {Dictionary[DICTIONARY.General].return}
              </Typography>
            </Stack>
          </Button>
        )}
        <Button
          onClick={next}
          sx={{
            width: isDesktop ? '180px' : '122px',
            p: 0,
            gap: '4px',
            ...primaryButtonSx,
          }}
          variant='primary1'
          disabled={nextDisabled}
        >
          <Stack direction={'row'} alignItems={'flex-end'} width={'auto'}>
            <Typography variant={'body4'}>
              {Dictionary[DICTIONARY.General].continue}
            </Typography>
            <DynamicArrow color={'white'} rotate={90} />
          </Stack>
        </Button>
      </Stack>
    </Stack>
  );
};
